import { z } from "@/zod";
import { timesheetEntryContractorVisit } from "@/schemas/timesheetEntryContractorVisit";
import { ulid } from "@/schemas/commonFields";
import { writeTimesheetEntry } from "@/schemas/timesheetEntry";
import { WriteTimesheetEntry } from "@/types/timesheetEntry";
import i18n from "@/i18n";

const timeSuperRefineFn = (data: WriteTimesheetEntry, ctx: z.RefinementCtx) => {
  const { start_datetime, end_datetime } = data;
  const allDefined = start_datetime !== undefined && end_datetime !== undefined;
  const noneDefined =
    start_datetime === undefined && end_datetime === undefined;

  if (!allDefined && !noneDefined) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: i18n.t("timesheetEntries.validation.startDatetimeRequired"),
      path: ["start_datetime"],
    });
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: i18n.t("timesheetEntries.validation.endDatetimeRequired"),
      path: ["end_datetime"],
    });
  }
};

export const formTimesheetEntryContractorVisit = timesheetEntryContractorVisit
  .omit({
    edit_allowed: true,
    contractor_id: true,
    contractor_name: true,
  })
  .readonly();

export const writeTimesheetEntryContractorVisit =
  writeTimesheetEntry.superRefine(timeSuperRefineFn);

export const writeTimesheetEntryContractor = writeTimesheetEntry
  .extend({
    original_id: ulid.nullable(),
  })
  .superRefine(timeSuperRefineFn);

export const writeTimesheetEntryContractorVisitFormSchema = z.object({
  entries: z.record(ulid, writeTimesheetEntryContractorVisit),
});

export const writeTimesheetEntryFormSchema = z.object({
  entries: z.record(ulid, writeTimesheetEntryContractor),
});

export const displayTimesheetEntryContractorVisit =
  timesheetEntryContractorVisit
    .extend({
      group_month: z.string(),
      group: z.string(),
    })
    .readonly();
